// extracted by mini-css-extract-plugin
module.exports = {"Marker":"ProjectMarker_Marker__2_hKN","MarkerTransparentBorder":"ProjectMarker_MarkerTransparentBorder__3_Q4Q","MarkerInner":"ProjectMarker_MarkerInner__2tSOz"};